// extracted by mini-css-extract-plugin
export default {"menuItems":"MenuItems_menuItems__pkpSy","menuLink":"MenuItems_menuLink__etvw1","scrolled":"MenuItems_scrolled__2IAKX"};